import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VScaleTransition } from 'vuetify/lib/components/transitions';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VScaleTransition,[(!_vm.menuOpenComputed)?_c(VBtn,{attrs:{"icon":""},on:{"click":_vm.toggleMainMenu}},[_c(VIcon,{attrs:{"size":"38","color":"primary"}},[_vm._v("lnr lnr-menu")])],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }